import React from 'react';

import { useResizeImage } from '@/components/player-profile/hooks/use-resize-image.web';
import { CONTAINER_SIZE } from '@/feature/player-profile-sheets/utils/player-profile-utils';

import './playerProfileImage.css';

type PlayerProfileSheetImageCanvasProps = {
    source: string;
    onError: (error: unknown) => void;
};

export const PlayerProfileSheetImageCanvas = ({ source, onError }: PlayerProfileSheetImageCanvasProps) => {
    const image = useResizeImage({ source, onError });
    return (
        <>
            {image ? (
                <img
                    src={image}
                    alt=""
                    className="playerProfileImage"
                    style={{
                        width: CONTAINER_SIZE.width,
                        height: CONTAINER_SIZE.height,
                    }}
                />
            ) : null}
        </>
    );
};
